<template lang="pug">
#modal-compartilhamento-relatorio
    el-dialog.modal-compartilhamento-relatorio-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :before-close='fecharModal',
        width='537px'
    )
        span(slot='title')
            h3
                b Compartilhar relatório de rastreabilidade

        .modal-compartilhamento-relatorio-conteudo
            .modal-compartilhamento-relatorio-conteudo-email
                .modal-compartilhamento-relatorio-conteudo-email-subtitulo__span
                    span.sub-tiulo Compartilhar via e-mail

                el-form(
                    ref='refFormCompartilhamento',
                    :model='formCompartilhamento',
                    :rules='regrasCompartilhamento',
                    @submit.native.prevent
                )
                    .modal-compartilhamento-relatorio-conteudo-email-envio
                        el-form-item(prop='email')
                            el-input.modal-compartilhamento-relatorio-conteudo-email-envio__input(
                                placeholder='Endereço de e-mail',
                                v-model='formCompartilhamento.email'
                            )

                        el-button.modal-compartilhamento-relatorio-conteudo-email-envio__button(
                            icon='mdi mdi-send',
                            @click='compartilharViaEmail',
                            type='primary'
                        ) Enviar
</template>

<script>
export default {
    name: 'ModalCompartilhamentoRelatorioRastreabilidade',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        numeroContrato: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            formCompartilhamento: {
                email: ''
            },
            regrasCompartilhamento: {
                email: [
                    {
                        required: true,
                        message: 'Informe um email',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Informe um email válido',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },

    methods: {
        fecharModal(done) {
            this.formCompartilhamento.email = '';
            this.$emit('voltar');
        },
        compartilharViaEmail() {
            this.$refs['refFormCompartilhamento'].validate(valid => {
                if (valid) {
                    this.$emit('enviarEmail', this.formCompartilhamento.email);
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss">
#modal-compartilhamento-relatorio {
    .modal-compartilhamento-relatorio-content {
        .el-dialog__header {
            padding: 20px;
            padding-bottom: 10px;
            padding-bottom: 12px;
            padding-top: 12px;
        }
        .el-dialog__headerbtn {
            top: 10px;
        }
        .el-dialog__headerbtn:hover .el-icon-close {
            color: #ffffff;
        }
        .modal-analise-elegibilidade--header {
            display: flex;
            align-items: center;
        }

        .sub-tiulo {
            font-weight: bold;
            color: var(--primary);
        }

        .modal-compartilhamento-relatorio-conteudo {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .modal-compartilhamento-relatorio-conteudo-email,
            .modal-compartilhamento-relatorio-conteudo-link {
                display: flex;
                flex-direction: column;
                gap: 8px;

                .modal-compartilhamento-relatorio-conteudo-email-envio,
                .modal-compartilhamento-relatorio-conteudo-link-envio {
                    display: flex;
                    justify-content: space-between;
                    gap: 15px;

                    .icone-link-compartilhar {
                        height: 100%;
                        display: flex;
                        align-items: center;
                        padding-right: 3px;
                    }

                    .el-input__inner {
                        color: #595858 !important;
                    }
                }
            }

            .modal-compartilhamento-relatorio-conteudo-separador {
                color: #cccccc;
                display: flex;
                justify-content: center;
                position: relative;

                .center-span::before,
                .center-span::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    width: 45%;
                    border-bottom: 2.3px solid #cccccc;
                }

                .center-span::before {
                    left: -5px;
                }

                .center-span::after {
                    right: -5px;
                }
            }
        }

        button.el-button.modal-compartilhamento-relatorio-conteudo-link-envio__button.el-button--primary {
            background-color: #24d366;
            border-color: #24d366;
            color: var(--white);
        }
        button.el-button.modal-compartilhamento-relatorio-conteudo-email-envio__button {
            height: 40px;
        }
    }

    i.mdi.mdi-send {
        margin-right: 7px;
    }
    .el-form-item {
        width: 100%;
    }
}
</style>
